committee = function (admin) {
	var objCommittee = {};
	var objDialog = dialog();
	var objRoleType = roleTypes();

	var url = '/admin/';

	if (admin === undefined || admin === null) {
		url = '/admin/';
	} else if (admin) {
		url = '/admin/';
	} else if (!admin) {
		url = '/';
	}

	/*
	 * Function createCommitteeList
	 * Purpose: populates the committees list in the right types column
	 */
	objCommittee.createCommitteeList = function(show) {
		var params = {
			display : 'ajaxList'
		};

		$.ajax({
			url: '/admin/committee',
			type: 'get',
			data: params,
			beforeSend: function() {
				domObject.addLoadingMask('#curriculog-types-column-content');
			},
			success: function(data) {
				$('.hierarchy-types').removeClass('active');

				$('#committees').remove();
				$(data).appendTo('#curriculog-types-column-content');

				if (show === true) {
					$('#committees').addClass('active');
				}

				domObject.removeMask('#curriculog-types-column-content');
				objCommittee.verticalStretch();
			}
		});

	};

	/*
	 * Function createCommitteeSelector
	 * Purpose: populates the committees list in a popup for agenda selection
	 */
	objCommittee.createCommitteeSelector = function() {
		$.get('/committees.json', function(data) {

			if ($('#curriculog-committee-selector-dialog').length === 0) {
				// make the dialog
				$('#committees-available').remove();

				$('<div id="curriculog-committee-selector-dialog"><ul id="committees-available"></ul></div>').appendTo('body');
				$('#curriculog-committee-selector-dialog').prop('title','Select a Committee');
				$('#curriculog-committee-selector-dialog').attr('class','single-field ui-dialog-content');

				$(data.committees).each(function(index, item) {
					var cleanName = DOMPurify.sanitize(item.name);
					$('#committees-available').append('<li id="committee-available-'+ item.id +'" class="select-field">' +
					'<button class="curriculog-add-widget committee value-'+ item.id +'">'+ cleanName +'</button></li>');
				});
			}
		});
	};

	/*
	 * Function createCommitteeSelect
	 * Purpose: populates the role types list in the right types column
	 */
	objCommittee.createCommitteeSelect = function(select, noneOption, callback) {
		// select variable could be a class or id. variable should include its type (ie #select-id or .select-id)

		var params = {
			display : 'ajaxSelect'
		};
		$.ajax({
			url: '/admin/committee',
			type: 'get',
			async: false,
			data: params,
			success: function(data){
				$(select).find('option').remove();

				// If there is an option for selecting None, add that to the top and select by default
				if (noneOption.length > 0) {
					$('<option value="">' + noneOption + '</option>').appendTo(select);
				}

				$(data).appendTo(select);

				// If there is a callback defined (like for preselecting an option), run it now
				callback && callback();
			}
		});
	};

	// objCommittee.refreshList = function() {
	// 	try {
	// 		var setActive = false;

	// 		if (($('div#curriculog-types-column-tooltabs li.active').attr('id')).replace('-tab','') === 'committees') {
	// 			setActive = true;
	// 		}

	// 		objCommittee.createCommitteeList(setActive);
	// 	} catch (e) {
	// 		console.error(e);
	// 	}
	// };

	objCommittee.openCommitteeSelector = function(successCallback) {
		var stepId = 0;

		// First, if no committees defined, tell user how to make them.
		var dialog;
		if ($('#committees-available li').length === 0) {
			dialog = objDialog.createBasicWarningDialog('no-committees-available', function(dialog, defaults) {
				// Message
				$(dialog).append('<p>There are no committees available. To add a new committee, please contact a system administrator.</p>');

				// Actions
				defaults.buttons = {
					'Ok': function() {
						$(this).dialog('close');
					}
				};
				$(dialog).dialog(defaults);
			});
		} else {

			$('#committees-available').empty();

			dialog = objDialog.createDOMDialog('curriculog-committee-selector-dialog', function(dialog, defaults) {

				// click event for choosing a committee
				$('#committees-available').on('click', '.committee', function(event) {
					event.preventDefault();
					event.stopPropagation();
					$(this).closest('.select-field').toggleClass('active');
				});

				// Get ONLY the committees for which this user is agenda admin
				eligibleCommittees = [];
				var eligibleCommitteesArray = ($('#agenda-eligible-committees').val()).split(',');
				$(eligibleCommitteesArray).each(function(index, item) {
					eligibleCommittees.push(+item);
				});

				$.ajax({
					url: '/committees.json',
					type: 'get',
					beforeSend: function() {
						objDom.addLoadingMask('#committees-available');
					},
					success: function(data){
						// add all eligible committees
						objDom.removeMask('#committees-available');
						$(data.committees).each(function(index, item) {
							if ($.inArray(item.id, eligibleCommittees) !== -1 && $.inArray(+$('input[name="agenda-user"]').val(), item.agendaAdmin) !== -1) {
								var cleanName = DOMPurify.sanitize(item.name);
								var hasAgenda = (item.hasActiveAgenda) ? ' has-agenda' : '';
								$('#committees-available').append('<li id="committee-available-'+ item.id +'" class="select-field">' +
								'<button class="curriculog-add-widget committee value-'+ item.id + hasAgenda + '">'+ cleanName +'</button></li>');
							}
						});

						// load in currently selected committees
						$('#agenda-committees .committee-item').each(function(index) {
							var committeeId = $(this).attr('id').match(/committee-(\d*)/)[1];
							$('#committees-available li.select-field .value-' + committeeId + ':not(.disabled)').closest('li').addClass('active');

						});
						Curriculog.Actions.log('committees-picker-loaded');
					}
				});

				// Actions
				defaults.buttons = {
					'Done Selecting Committees': function() {
						var committees = [];

						// Remove current committees from the list
						$('#agenda-committees .committee-item').remove();

						// Add the items to the DOM
						$('#committees-available li.active').each(function(index) {
							var chosenCommittee = $(this).attr('id').match(/committee-available-(\d*)/)[1];
							var committeeHTML = $('#committee-clone').clone().attr({'id':'committee-'+chosenCommittee, 'tabindex': '0'}).append($(this).find('button').text());
							$(committeeHTML).appendTo($('#agenda-committees'));
						});
						$('#curriculog-committee-selector-dialog').dialog('close');

						successCallback && successCallback();
					},
					Cancel: function() {
						$(this).dialog('close');
					}
				};

				defaults.close = function(event, ui) {
					// Clear out the selected items before the next use
					$('#committees-available').off('click', '.committee');
					// clear out old selected items
					$('#committees-available li').removeClass('active');
				};

				$(dialog).dialog(defaults);
			});
		}
	};


	/*
	 * Function newRoleType
	 * Purpose: gathers information from the form to update
	 * or create new role type
	 */
	// objCommittee.newCommittee = function() {
	// 	try {
	// 		// Disable the form
	// 		$('#committees .type-submit').attr('disabled', 'disabled');

	// 		var postData = {
	// 			name:$('#committee-name').val()
	// 		};

	// 		if ($('#committee-id').val().trim().length !== 0) {
	// 			var putUrl = '/admin/committee:' + $('#committee-id').val().trim();
	// 			$.ajax({
	// 				url: putUrl,
	// 				type: 'put',
	// 				data: postData,
	// 				beforeSend: function() {
	// 					domObject.addLoadingMask('.curriculog-types-new-type');
	// 				},
	// 				success: function(){
	// 					domObject.removeMask('.curriculog-types-new-type');
	// 					objCommittee.createCommitteeList(true);
	// 				}
	// 			});
	// 		} else {
	// 			$.ajax({
	// 				url: '/admin/committee',
	// 				type: 'POST',
	// 				data: postData,
	// 				beforeSend: function() {
	// 					domObject.addLoadingMask('.curriculog-types-new-type');
	// 				},
	// 				success: function(){
	// 					domObject.removeMask('.curriculog-types-new-type');
	// 					objCommittee.createCommitteeList(true);
	// 				}
	// 			});
	// 		}
	// 	} catch (err) {
	// 		return false;
	// 	}
	// };

	// objCommittee.editCommittee = function(committeeId) {
	// 	if (committeeId === undefined || committeeId === null) {
	// 		return false;
	// 	}

	// 	// Set role name in form
	// 	$('#committee-name').val($('#' + committeeId + ' .type-name').html().trim());

	// 	//Set role type id
	// 	$('#committee-id').val(committeeId.replace('committee-', ''));

	// 	// Change submit button to say 'Update Type'
	// 	$('#committees .type-submit').attr('value','Update Committee').removeAttr('disabled');
	// 	$('#committees .type-reset').removeAttr('disabled');
	// 	$('#committees li.curriculog-types-new-type form h1').text('Update Committee');
	// };



	objCommittee.cannotRemove = function(committeeId) {
		$('#' + committeeId).addClass('curriculog-remove-warning-highlight');

		var dialog = objDialog.createBasicWarningDialog('cannot-remove', function(dialog, defaults) {

			// Message
			$(dialog).append('You cannot remove <span class="strong">' + $('#' + committeeId + ' .type-name').html() + '</span> because it is currently being used.');
			$(dialog).append('To make this committee removeable you will have to remove all roles associated with this committee from all Approval Processes and complete/delete all proposals using it.');
			// Actions
			defaults.buttons = {
				'OK': function() {
					$('#' + committeeId).removeClass('curriculog-remove-warning-highlight');
					$('div.qtip-active').remove();
					$(this).dialog('close');
					$(this).remove();
				}
			};
			$(dialog).dialog(defaults);
		});
	};

	objCommittee.destroy = function(committee) {
		$('#' + committee.id).addClass('curriculog-remove-warning-highlight');

		var dialog = objDialog.createBasicWarningDialog('remove-committee-type', function(dialog, defaults) {
			// Message
			$(dialog).append('You are deleting the <span class="strong">' + committee.name + '</span> committee. Are you sure you want to continue?');
			// Actions
			defaults.buttons = {
				'Delete Committee': function() {

					$.ajax({
						url: '/admin/committee:' + committee.id + '.json',
						type: 'delete',
						beforeSend: function() {
							objDom.addMask('#committees');
						},
						success: function (result) {
							if (+result.success === 1) {
								objCommittee.createCommitteeList(true);
							} else {
								objCommittee.deleteFailed(committee.id);
							}
							objDom.removeMask('#committees');
						}
					});
					$('div.qtip-active').remove();
					$(this).dialog('close');
					$(this).remove();
				},
				Cancel: function() {
					$('#' + committee.id).removeClass('curriculog-remove-warning-highlight');
					$(this).dialog('close');
					$(this).remove();
				}
			};
			$(dialog).dialog(defaults);
		});
	};

	// objCommittee.resetCommitteeForm = function() {
	// 	try {
	// 		//Set role type id
	// 		$('#committee-id').val('');

	// 		// Change submit button to say 'Update Type'
	// 		$('#committees .type-submit').attr('value','Create Committee');
	// 		$('#committees li.curriculog-types-new-type form h1').text('New Committee');
	// 		objRoleTypes.createCommitteeList(true);
	// 	} catch(err) {
	// 		return false;
	// 	}
	// };

	objCommittee.validateForm = function(typeId, which) {
		if (which !== 13) {
			if ($(typeId).val().trim() === '') {
				$('#committees .type-submit').attr('disabled', 'disabled');
				$('#committees .type-reset').attr('disabled', 'disabled');
			} else {
				$('#committees .type-submit').removeAttr('disabled');
				$('#committees .type-reset').removeAttr('disabled');
			}
		}
	};

	objCommittee.deleteFailed = function(currentId) {
		try {
			if (currentId === undefined || currentId === null) {
				return false;
			}

			var typeId = 'committee-' + currentId;

			$('#' + typeId).addClass('curriculog-remove-warning-highlight');
			var dialog = objDialog.createBasicWarningDialog('committee-delete-failed', function(dialog, defaults) {
				// Message
				$(dialog).append('The "' + $('#' + typeId + ' .type-name').html() + '" committee could not be deleted at this time.');
				// Actions
				defaults.buttons = {
					'Ok': function() {
						$('#' + typeId).removeClass('curriculog-remove-warning-highlight');
						$(this).dialog('close');
						$(this).remove();
					}
				};
				$(dialog).dialog(defaults);
			});
		} catch (err) {
			return false;
		}
	};

	objCommittee.getCommittees = function(removeTagId) {
		$.ajax({
			url: '/admin/committee',
			type: 'get',
			async: false,
			data: {display: 'ajaxSelect'},
			success: function(data){
				$('#new-committee').contents().remove();

				$(data).each(function(index) {
					if ($(this).val() !== removeTagId) {
						$('#new-committee').append($(this));
					}
				});
			}
		});
	};

	objCommittee.populateDeleteOptions = function(obj) {
		var roleTypesList = objRoleType.getNonCommitteeRoleTypes();

		$('#non-committee-role-types').contents().remove();
		$.each(roleTypesList, function(roleTypeId, roleTypeName) {
			$('#non-committee-role-types').append($('<option></option>').val(roleTypeId).html(roleTypeName));
		});

		objCommittee.getCommittees(obj.id);
	};

	objCommittee.deleteOptions = function(obj, callback) {
		var dialog = objDialog.createBasicWarningDialog('tag-delete-options', function(dialog, defaults) {


			defaults.open = function() {
				objCommittee.populateDeleteOptions(obj);
			};

			// Message
			$(dialog).append('Before we calculate for conflicts, would you like to replace the roleType for all roles with a non-committee roleType ');
			$(dialog).append('or replace the committee?');
			$(dialog).append('<div style="margin:10px;"></div>');
			$(dialog).append('<div class="clear"><span class="strong">Select a Role Type to replace them with.</span>');
			$(dialog).append('<select id="non-committee-role-types"></select></div>');
			$(dialog).append('<div style="margin:10px;"></div>');
			$(dialog).append('<div class="clear"><span class="strong">Select a Committee to replace with.</span>');
			$(dialog).append('<select id="new-committee"></select></div>');

			defaults.buttons = [
				{
					id: 'delete-tag-replace-roleType',
					text: 'Replace the RoleType',
					click: function() {
						obj.replaceId = $('#non-committee-role-types').val();
						obj.replaceType = 'nonCommittee';
						callback && callback(obj);
						$(this).dialog('close');
						$(this).remove();
					}

				},
				{
					id: 'delete-tag-replace-committee',
					text: 'Replace the Committee',
					click: function() {
						obj.replaceId = $('#new-committee').val();
						obj.replaceType = 'newCommittee';
						callback && callback(obj);
						$(this).dialog('close');
						$(this).remove();
					}
				},
				{
					id: 'delete-tag-cancel',
					text: 'Cancel',
					click: function() {
						$(this).dialog('close');
						$(this).remove();
					}
				}
			];

			$(dialog).dialog(defaults);

			if ($('#new-committee').children().length === 0) {
				$('#delete-tag-replace-committee').attr('disabled', true);
			}

			if ($('#non-committee-role-types').children().length === 0) {
				$('#delete-tag-replace-roleType').attr('disabled', true);
			}
		});
	};

	objCommittee.deleteTagFromRoleOptions = function(obj, callback) {
		var dialog = objDialog.createBasicWarningDialog('tag-delete-from-role-options', function(dialog, defaults) {

			console.log(obj);

			defaults.open = function() {
				var roleTypesList = objRoleType.getNonCommitteeRoleTypes();

				$('#non-committee-role-types').contents().remove();
				$.each(roleTypesList, function(roleTypeId, roleTypeName) {
					$('#non-committee-role-types').append($('<option></option>').val(roleTypeId).html(roleTypeName));
				});
			};

			// Message
			$(dialog).append('Before we calculate for conflicts, you need to select a roleType to replace the committee roleType that is associated with this role. ');
			$(dialog).append('<div style="margin:10px;"></div>');
			$(dialog).append('<div class="clear"><span class="strong">Select a Role Type to replace them with.</span>');
			$(dialog).append('<select id="non-committee-role-types"></select></div>');

			// Actions
			defaults.buttons = {
				'Replace the RoleType': function() {
					obj.roleTypeId = $('#non-committee-role-types').val();
					callback && callback(obj);
					$(this).dialog('close');
					$(this).remove();
				},
				'Cancel': function() {
					$(this).dialog('close');
					$(this).remove();
				}
			};
			$(dialog).dialog(defaults);
		});
	};

	objCommittee.deleteTag = function(obj) {
		var dialog = objDialog.createBasicWarningDialog('delete-tag-dialog', function(dialog, defaults) {

			$(dialog).append('Are you sure you want to remove Committee <span class="strong">'+ obj.name + '</span>');

			defaults.buttons = {
				'Delete Committee': function() {

					$.ajax({
						url: '/admin/committee:' + obj.id + '.json',
						type: 'delete',
						beforeSend: function() {
							objDom.addMask('#committees');
						},
						success: function (result) {
							if (result.success === 1) {
								objCommittee.createCommitteeList(true);
							} else {
								objCommittee.deleteFailed(committeeId);
							}
							objDom.removeMask('#committees');
						}
					});

					$('div.qtip-active').remove();
					$(this).dialog('close');
					$(this).remove();
				},
				Cancel: function() {
					$(this).dialog('close');
					$(this).remove();
				}
			};

			$(dialog).dialog(defaults);
		});
	};


	objCommittee.verticalStretch = function() {
		var col1 = '#curriculog-hierarchy-column-content';
		var col2 = '#curriculog-types-column-content';
		domObject = dom();
		domObject.verticalStretchForm(col1, col2);
	};


	return objCommittee;
};